import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

// - Farger
export const GET_FARGER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/farger`;
export const POST_FARGE_URL = `${ILEGGELSE_SERVICE_BASE_URL}/farger`;
export const PUT_FARGE_URL = (id) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/farger/${id}`;
